// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel-module__panel___3i2ug","padded":"Panel-module__padded___2ysgt","gradient":"Panel-module__gradient___17ZDd"};